import { FormattedNumber } from 'components/shared/Intl';
import { FC } from 'react';
import { connect } from 'react-redux';
import type { BasketOptimizerResultRow } from 'state/advisory/basket-optimizer/model';
import { getResultRows } from 'state/advisory/basket-optimizer/selectors';
import type { AppState } from 'state/state.model';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

export interface OptimizedBasketsFieldProps {
  optimizedBasketResults: BasketOptimizerResultRow[];
}

const mapStateToProps = (state: AppState): OptimizedBasketsFieldProps => {
  const tabId = getWorkspaceActiveTabId(state, 'static')!;
  const optimizedBasketResults = getResultRows(state, tabId) || [];

  return {
    optimizedBasketResults,
  };
};

export const connectOptimizedBaskets = connect(mapStateToProps);

export const Component: FC<OptimizedBasketsFieldProps> = ({ optimizedBasketResults }) => {
  return (
    <table className="table table-sm table-striped">
      <tbody>
        {optimizedBasketResults.map(basketResult => {
          return (
            <tr
              className="text-regular fw-light m-0"
              data-e2e="basketResult-row"
              key={`${basketResult.underlyingIds.join('-')}-${basketResult.price}`}
            >
              <td>{`${basketResult.underlyingIds.join(', ')}`}</td>
              <td>
                <FormattedNumber maximumFractionDigits={4} minimumFractionDigits={4} value={basketResult.price} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
export const OptimizedBasketsField = connectOptimizedBaskets(Component);
OptimizedBasketsField.displayName = 'OptimizedBasketsField';
